import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./automobile.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const Automobile = () => {
  return (
    <div className="automobile-industry-wrapper">
      <Particles title="automobile" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default Automobile;
